import { render, staticRenderFns } from "./employeePanel.vue?vue&type=template&id=08721d7b&scoped=true"
import script from "./employeePanel.vue?vue&type=script&lang=js"
export * from "./employeePanel.vue?vue&type=script&lang=js"
import style0 from "./employeePanel.vue?vue&type=style&index=0&id=08721d7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08721d7b",
  null
  
)

export default component.exports